[
	{
		"display": "false",
		"ui_columnname": "Action Type",
		"db_columnname": "actionType",
		"datatype": "String",
		"mappingkey": "actionType",
		"dropdown": "YES",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Error ROE ID",
		"db_columnname": "errorROEID",
		"datatype": "String",
		"mappingkey": "errorROEID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Firm ROE ID",
		"db_columnname": "firmROEID",
		"datatype": "String",
		"mappingkey": "firmROEID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Type",
		"db_columnname": "type",
		"datatype": "String",
		"mappingkey": "type",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "CAT Reporter IMID",
		"db_columnname": "CATReporterIMID",
		"datatype": "String",
		"mappingkey": "CATReporterIMID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "true",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Trade Order Key Date",
		"db_columnname": "tradeKeyDate",
		"datatype": "String",
		"mappingkey": "tradeKeyDate",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "true",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Trade ID",
		"db_columnname": "tradeID",
		"datatype": "String",
		"mappingkey": "tradeID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Symbol",
		"db_columnname": "symbol",
		"datatype": "String",
		"mappingkey": "symbol",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Order Key Date",
		"db_columnname": "orderKeyDate",
		"datatype": "String",
		"mappingkey": "orderKeyDate",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Order ID",
		"db_columnname": "orderID",
		"datatype": "String",
		"mappingkey": "orderID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Side",
		"db_columnname": "side",
		"datatype": "String",
		"mappingkey": "side",
		"dropdown": "Yes",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "singleselect",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Firm Designated ID",
		"db_columnname": "firmDesignatedID",
		"datatype": "String",
		"mappingkey": "firmDesignatedID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Account Holder Type",
		"db_columnname": "accountHolderType",
		"datatype": "String",
		"mappingkey": "accountHolderType",
		"dropdown": "Yes",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "singleselect",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Originating IMID",
		"db_columnname": "originatingIMID",
		"datatype": "String",
		"mappingkey": "originatingIMID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "BFMMFlag",
		"db_columnname": "BFMMFlag",
		"datatype": "Boolean",
		"mappingkey": "BFMMFlag",
		"dropdown": "NO",
		"isdefault":  "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "singleselect",
		"dropdownvalue": ""
	}
]